import { render } from "./PostBit.vue?vue&type=template&id=5bfeb9d4&scoped=true"
import script from "./PostBit.vue?vue&type=script&lang=js"
export * from "./PostBit.vue?vue&type=script&lang=js"

import "./PostBit.vue?vue&type=style&index=0&id=5bfeb9d4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bfeb9d4"]])

export default __exports__